import { IUserDefinedItemSelectBehavior, IUserDefinedItemSelectBehaviorSpecifiable } from "../../../../../../../documaker/domain/format/objects";
import { IXElementContentsObjectBean } from "../../../beans";
import { IObjectBeanUserDefinitionSelectable } from "../../../beans/objects";
import { UserDefinedInformationWindowKindTranslator } from "./UserDefinedInformationWindowKindTranslator";

export class UserDefinedItemSelectBehaviorTranslator {
  from(bean: IXElementContentsObjectBean & IObjectBeanUserDefinitionSelectable): IUserDefinedItemSelectBehavior {
    return {
      windowKind: this.windowKind.from(bean),
      shouldSelectRow: (bean["@select-mode"] !== "2"),
    };
  }

  to(object: IUserDefinedItemSelectBehaviorSpecifiable) {
    return {
      selectMode: object.userDefinedItemSelectBehavior.shouldSelectRow
        ? undefined
        : "2",
      relationalWindowType: this.windowKind.to(object.userDefinedItemSelectBehavior.windowKind),
    };
  }

  private readonly windowKind = new UserDefinedInformationWindowKindTranslator();
}
